export const createRequestFunction = (axiosArgs, globalAxios) => {
  const axiosRequestArgs = { ...axiosArgs.options, url: axiosArgs.url };
  return globalAxios.request(axiosRequestArgs);
};
